import { useEffect } from 'react';

/**
 * Wires Cmd+S (mac) / Ctrl+S (win/linux) to a save handler while mounted.
 * Prevents the browser's "save page" dialog and calls `onSave` instead, so any
 * form that adopts this gets keyboard save with the same validation/error
 * highlighting as clicking the Save button.
 */
export const useSaveShortcut = (onSave: () => void, enabled = true): void => {
  useEffect(() => {
    if (!enabled) return;
    const handler = (e: KeyboardEvent): void => {
      if ((e.metaKey || e.ctrlKey) && (e.key === 's' || e.key === 'S')) {
        e.preventDefault();
        onSave();
      }
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onSave, enabled]);
};
